export default __webpack_public_path__ + "static/media/file-green.cd31b998.svg";